import React, { useEffect, useMemo } from 'react';

import { Event as CustomEvent } from '@yandex-int/messenger.utils';
import { useSelector } from 'react-redux';

import { SELF } from '../../../../shared/constants';
import { isMobileUa } from '../../../../shared/features/uatraits/selectors';
import { countMetrika } from '../../../../shared/helpers/metrika';
import { BroadcastStatus } from '../../../../types';
import { CloudRecordingTile } from '../../features/cloud-recording/components';
import { useParticipantModerationPopup } from '../../hooks/participant-moderation-popup';
import {
    getBroadcastStarterUid,
    getBroadcastStatus,
    selectCanWatchWaitingRoom,
    selectSortedParticipants,
} from '../../selectors';
import { ConferenceLimitWarning } from '../conference-limit-warning';
import { ParticipantComponent } from './participant';

export const ParticipantsList = () => {
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ // TODO: разобраться зачем нужно, кажется, не работает
    const onParticipantListChanged = new CustomEvent();

    const sortedParticipants = useSelector(selectSortedParticipants);
    const isMobile = useSelector(isMobileUa);
    const broadcastStarterUid = useSelector(getBroadcastStarterUid);
    const broadcastStatus = useSelector(getBroadcastStatus);
    const canWatchWaitingRoom = useSelector(selectCanWatchWaitingRoom);

    const { showModerationPopupId, openModerationPopup, closeModerationPopup } = useParticipantModerationPopup();

    const participantList = useMemo(() => {
        const list = sortedParticipants.map((participant) => {
            const { id, uid, isLocalRecording } = participant;

            const isBroadcasting = broadcastStatus === BroadcastStatus.STARTED && broadcastStarterUid === uid;

            return (
                <ParticipantComponent
                    key={id}
                    participant={participant}
                    showModerationPopup={id === showModerationPopupId && id !== SELF}
                    showRecordingIcon={isLocalRecording && id !== SELF}
                    showBroadcastIcon={isBroadcasting && id !== SELF}
                    openModerationPopup={() => openModerationPopup(id)}
                    closeModerationPopup={closeModerationPopup}
                    isMobile={isMobile}
                    onParticipantListChanged={onParticipantListChanged}
                />
            );
        });

        return list;
    }, [
        sortedParticipants,
        broadcastStatus,
        broadcastStarterUid,
        showModerationPopupId,
        closeModerationPopup,
        isMobile,
        onParticipantListChanged,
        openModerationPopup,
    ]);

    useEffect(() => {
        countMetrika('meeting_screen', 'participants_list', 'show');
    }, []);

    return (
        <>
            {canWatchWaitingRoom ? <ConferenceLimitWarning /> : null}
            <CloudRecordingTile />
            {participantList}
        </>
    );
};
